import { render } from "./risk-board.vue?vue&type=template&id=0bdc3912&scoped=true&ts=true"
import script from "./risk-board.vue?vue&type=script&lang=ts"
export * from "./risk-board.vue?vue&type=script&lang=ts"

import "./risk-board.vue?vue&type=style&index=0&id=0bdc3912&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdc3912"]])

export default __exports__